import React from "react";
import cx from "classnames";
import s from "./domainRow.scss";
import PropTypes from "prop-types";
import t from "Utils/translation";
import DropdownMenu from "Components/dropdownMenu/DropdownMenu";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import { Icon, trash, enable, manager, disable, more } from "Icons/index";
import Tooltip from "Components/tooltip/Tooltip";
import DeliveryDomainStatusBadge from "../deliveryDomainStatusBadge/DeliveryDomainStatusBadge";

const ContextTypes = {
  isLoggedUserAdmin: PropTypes.func,
  getLoggedUser: PropTypes.func,
};

export default class DomainRow extends React.Component {
  constructor(props, context) {
    super(props);
    const loggedUser = context.getLoggedUser();

    this.state = {
      isLoggedUserManager: loggedUser.type === "Manager",
      isMenuOpen: false,
      isAdmin: context.isLoggedUserAdmin(),
    };
  }

  onMenuOpenChange = (newVal) => {
    this.setState({ isMenuOpen: newVal });
  };

  goTo = (resource, domainCode, customerCode = null) => {
    const { search } = this.props.location;
    let nextUrl;

    if (this.props.domain.status === "ownership_check") {
      this.showOwnershipCheck(domainCode);
      return;
    }

    if (this.props.isLoggedUserAdmin) {
      nextUrl = `/customers/${customerCode}/domains/${domainCode}/${resource}`;
    } else {
      nextUrl = `/domains/${domainCode}/${resource}`;
    }

    this.props.history.push({
      pathname: nextUrl,
      state: {
        prevPagination: search,
      },
    });
  };

  showOwnershipCheck = (code) => {
    this.props.history.push({
      pathname: `/domains/${code}/ownership_check`,
      state: {
        prevPagination: this.props.location.search,
      },
    });
  };

  showOwnershipCheckEmail = (code) => {
    this.props.history.push({
      pathname: `/domains/${code}/ownership_check#email`,
      state: {
        prevPagination: this.props.location.search,
      },
    });
  };

  showDomainOrOwnershipCheck = (code, customerCode = null) => {
    const { search } = this.props.location;
    let nextUrl;
    if (this.props.domain.status === "ownership_check") {
      this.showOwnershipCheck(code);
      return;
    } else if (this.props.isLoggedUserAdmin) {
      nextUrl = `/customers/${customerCode}/delivery/domains/${code}/accounts`;
    } else {
      nextUrl = `/delivery/domains/${code}/accounts`;
    }

    this.props.history.push({
      pathname: nextUrl,
      state: {
        prevPagination: search,
      },
    });
  };

  render() {
    const { domain: dom, isLoggedUserAdmin } = this.props;
    const { isLoggedUserManager } = this.state;
    const loggedUser = this.context.getLoggedUser();

    let canDelete = true;
    let canEnable = true;
    if (
      dom.status === "disabled" &&
      (dom.status_detail === "admin" || dom.status_detail === "system") &&
      !isLoggedUserAdmin
    ) {
      canEnable = false;
      canDelete = false;
    }

    if (isLoggedUserManager && dom.status === "disabled" && dom.status_detail !== "manager") {
      canEnable = false;
    }

    if (loggedUser.type === "TeamMember") {
      if (!loggedUser.permissions.includes("delete_domains")) {
        canDelete = false;
      }

      if (!loggedUser.permissions.includes("disable_domains")) {
        canEnable = false;
      }
    }

    if (loggedUser.type === "Admin" && dom.status_detail === "wait_delete") {
      canDelete = false;
    }

    const hideMenu =
      dom.status === "failure" ||
      dom.status === "updating" ||
      (dom.status_detail === "wait_delete" && !this.state.isAdmin) ||
      (!canEnable && !canDelete);

    return (
      <tr key={dom.code}>
        <td data-label={t("table.header.status")} className={s.justifyCenter}>
          <DeliveryDomainStatusBadge domain={dom} />
        </td>
        <td data-label={t("table.header.domain")}>
          {dom.status === "updating" ? (
            dom.name
          ) : (
            <a onClick={() => this.showDomainOrOwnershipCheck(dom.code, dom.customer_code)}>{dom.name}</a>
          )}
        </td>

        {isLoggedUserAdmin && (
          <td data-label={t("table.header.customer")} className="hideOnMobile">
            {dom.customer_fullname}
          </td>
        )}

        <td data-label={t("table.header.accounts")} className="hideOnMobile">
          <DeliveryDomainStatusBadge domain={dom} textOnly />
        </td>
        <td data-label={t("table.header.managers")} className={cx("hideOnMobile")}>
          <a onClick={() => this.showDomainOrOwnershipCheck(dom.code, dom.customer_code)}>
            {dom.accounts_count ? dom.accounts_count : 0}
          </a>
        </td>

        <td data-label={t("table.header.managers")} className={cx(s.justifyCenter, "hideOnMobile")}>
          {dom.manager_fullname && !this.state.isLoggedUserManager && (
            <Tooltip title="manager" text={dom.manager_fullname}>
              <Icon svg={manager} />
            </Tooltip>
          )}
        </td>

        <td className={s.justifyCenter}>
          <DropdownMenu
            isOpen={this.state.isMenuOpen}
            onOpenChange={this.onMenuOpenChange}
            hideToggle={hideMenu}
            actions={[
              {
                isHidden: !canEnable || dom.status !== "enabled",
                onClick: () => this.props.changeDomainStatus(dom.code, "disabled"),
                icon: disable,
                label: t("ddMenu.disable"),
              },
              {
                isHidden: !canEnable || dom.status !== "disabled",
                onClick: () => this.props.changeDomainStatus(dom.code, "enabled"),
                icon: enable,
                label: t("ddMenu.enable"),
              },
              {
                isHidden: !canDelete,
                onClick: () => this.props.deleteDomain(dom),
                icon: trash,
                label: t("ddMenu.delete"),
              },
            ]}
          >
            <ButtonIcon icon={more} />
          </DropdownMenu>
        </td>
      </tr>
    );
  }
}

DomainRow.contextTypes = ContextTypes;
